export default function Experience() {
  return (
    <div className="experience">
      <section>
        <div>
          <h1 className="heading">Experience</h1>
          <ul>
            <li>
              <div className="num">2+</div>
              <div className="desc">Years of experience.</div>
            </li>
            <li>
              <div className="num">5+</div>
              <div className="desc">Satisfied clients.</div>
            </li>
          </ul>
        </div>
        <div className="experience-text">
          <span className="span">/ Problem solver</span>
          <h3>
            I derive great satisfaction from solving problems, utilizing my
            skills and creativity to find innovative solutions.
          </h3>
          <p>
            Passionate web developer crafting immersive online experiences with
            a focus on user-centric design and seamless functionality.
          </p>
        </div>
      </section>
    </div>
  );
}
